import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  backButton: {
    width: '18px',
    height: '20px',
    cursor: 'pointer',
    color: theme.palette.select.light,
    '&:hover': {
      opacity: 0.8,
    },
  },
  companyLogo: {
    width: '32px',
    height: '32px',
    border: '-0.5px',
    borderRadius: theme.spacing(0.5),
  },
  companyName: {
    fontWeight: 400,
    fontSize: theme.spacing(2.75),
    lineHeigth: theme.spacing(3.5),
  },
}))
